import { Navigate } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import BusCoachPage from "@/pages/BusCoachPage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ContactPage from "@/pages/ContactPage";
import LeadershipPage from "@/pages/LeadershipPage";
import SustainabilityPage from "@/pages/SustainabilityPage";
import MediaCenterPage from "@/pages/MediaCenterPage";
import EuropcarPage from "@/pages/EuropcarPage";
import AiCarRentalPage from "@/pages/AiCarRentalPage";
import KioskPage from "@/pages/KioskPage";
import GoldcarPage from "@/pages/GoldcarPage";
import TrucklinePage from "@/pages/TrucklinePage";
import UsedCarsPage from "@/pages/UsedCarsPage";
import CareersPage from "@/pages/CareersPage";
import BookChauffeurPage from "@/pages/BookChauffeurPage";
import CollaboratePage from "@/pages/CollaboratePage";
import PartnershipPage from "@/pages/PartnershipPage";
import CorporateRentalLeasePage from "@/pages/CorporateRentalLeasePage";
import AirportTransferPage from "@/pages/AirportTransferPage";
import HospitalitySuitePage from "@/pages/HospitalitySuitePage";
import StaffTransportPage from "@/pages/StaffTransportPage";
import LeasingPage from "@/pages/LeasingPage";
import ChauffeurServicePage from "@/pages/ChauffeurServicePage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import PartnersClientsPage from "@/pages/PartnersClientsPage";
import DubaiMunicipalityPage from "@/pages/DubaiMunicipalityPage";
import MobilityTechPage from "@/pages/MobilityTechPage";
import FAQPage from "@/pages/FAQPage";
import PortalPage from "@/pages/PortalPage";
import SEOCarRentalDubai from "@/pages/seo/SEOCarRentalDubai";
import SEOMonthlyRental from "@/pages/seo/SEOMonthlyRental";
import SEOChauffeurDubai from "@/pages/seo/SEOChauffeurDubai";
import SEOCommercialLeasing from "@/pages/seo/SEOCommercialLeasing";
import SEOCarLeasingDubai from "@/pages/seo/SEOCarLeasingDubai";
import HomePageAr from "@/pages/ar/HomePageAr";
import AboutPageAr from "@/pages/ar/AboutPageAr";
import ContactPageAr from "@/pages/ar/ContactPageAr";
import ServicesPageAr from "@/pages/ar/ServicesPageAr";
import EuropcarPageAr from "@/pages/ar/EuropcarPageAr";
import ChauffeurPageAr from "@/pages/ar/ChauffeurPageAr";
import LeasingPageAr from "@/pages/ar/LeasingPageAr";
import CareersPageAr from "@/pages/ar/CareersPageAr";
import PartnerPageAr from "@/pages/ar/PartnerPageAr";
import GoldcarPageAr from "@/pages/ar/GoldcarPageAr";
import TrucklinePageAr from "@/pages/ar/TrucklinePageAr";
import UsedCarsPageAr from "@/pages/ar/UsedCarsPageAr";
import SustainabilityPageAr from "@/pages/ar/SustainabilityPageAr";
import MediaCenterPageAr from "@/pages/ar/MediaCenterPageAr";
import LeadershipPageAr from "@/pages/ar/LeadershipPageAr";
import FAQPageAr from "@/pages/ar/FAQPageAr";
import DownloadsPageAr from "@/pages/ar/DownloadsPageAr";
import BusinessesPageAr from "@/pages/ar/BusinessesPageAr";
import PortalPageAr from "@/pages/ar/PortalPageAr";
import NotFoundPage from "@/pages/NotFoundPage";
import AuctionCatalogPage from "@/pages/AuctionCatalogPage";
import AuctionLotPage from "@/pages/AuctionLotPage";
import AuctionAdminPage from "@/pages/AuctionAdminPage";
import LoginPage from "@/pages/account/LoginPage";
import RegisterPage from "@/pages/account/RegisterPage";
import ForgotPasswordPage from "@/pages/account/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/account/ResetPasswordPage";
import AccountPage from "@/pages/account/AccountPage";
import UaePassCompletePage from "@/pages/account/UaePassCompletePage";

export const ROUTES = [
  { path: "/", element: <HomePage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/leadership", element: <LeadershipPage /> },
  { path: "/sustainability", element: <SustainabilityPage /> },
  { path: "/media", element: <MediaCenterPage /> },
  { path: "/europcar", element: <EuropcarPage /> },
  { path: "/ai-car-rental", element: <AiCarRentalPage /> },
  { path: "/ai-car-rental/kiosk", element: <KioskPage /> },
  { path: "/goldcar", element: <GoldcarPage /> },
  { path: "/royal-limousine", element: <BusCoachPage /> },
  { path: "/emirates-taxi", element: <ChauffeurServicePage /> },
  { path: "/truckline", element: <TrucklinePage /> },
  { path: "/used-cars", element: <UsedCarsPage /> },
  { path: "/auction", element: <AuctionCatalogPage /> },
  { path: "/auction/lot/:id", element: <AuctionLotPage /> },
  { path: "/auction-admin", element: <AuctionAdminPage /> },
  { path: "/careers", element: <CareersPage /> },
  { path: "/businesses", element: <Navigate to="/services" replace /> },
  { path: "/book-chauffeur", element: <BookChauffeurPage /> },
  { path: "/ar/book-chauffeur", element: <BookChauffeurPage lang="ar" /> },
  { path: "/leasing", element: <LeasingPage /> },
  { path: "/corporate-rental-lease", element: <CorporateRentalLeasePage /> },
  { path: "/airport-transfer", element: <AirportTransferPage /> },
  { path: "/chauffeur-service", element: <ChauffeurServicePage /> },
  { path: "/collaborate", element: <CollaboratePage /> },
  { path: "/collaborate/:slug", element: <PartnershipPage /> },
  { path: "/hospitality", element: <HospitalitySuitePage /> },
  { path: "/staff-transport", element: <StaffTransportPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/register", element: <RegisterPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password/:token", element: <ResetPasswordPage /> },
  { path: "/account", element: <AccountPage /> },
  { path: "/uaepass/complete", element: <UaePassCompletePage /> },
  { path: "/admin/login", element: <AdminLoginPage /> },
  { path: "/admin", element: <AdminDashboardPage /> },
  { path: "/partners", element: <PartnersClientsPage /> },
  { path: "/dubai-municipality", element: <DubaiMunicipalityPage /> },
  { path: "/mobility-technology", element: <MobilityTechPage /> },
  { path: "/autocare", element: <Navigate to="/services" replace /> },
  { path: "/partner", element: <Navigate to="/collaborate" replace /> },
  { path: "/faq", element: <FAQPage /> },
  { path: "/downloads", element: <Navigate to="/" replace /> },
  { path: "/portal/corporate", element: <PortalPage /> },
  { path: "/portal/driver", element: <PortalPage /> },
  { path: "/car-rental-dubai", element: <SEOCarRentalDubai /> },
  { path: "/monthly-car-rental-dubai", element: <SEOMonthlyRental /> },
  { path: "/chauffeur-service-dubai", element: <SEOChauffeurDubai /> },
  { path: "/commercial-vehicle-leasing-uae", element: <SEOCommercialLeasing /> },
  { path: "/car-leasing-dubai", element: <SEOCarLeasingDubai /> },
  { path: "/ar", element: <HomePageAr /> },
  { path: "/ar/about", element: <AboutPageAr /> },
  { path: "/ar/contact", element: <ContactPageAr /> },
  { path: "/ar/services", element: <ServicesPageAr /> },
  { path: "/ar/europcar", element: <EuropcarPageAr /> },
  { path: "/ar/chauffeur-service", element: <ChauffeurPageAr /> },
  { path: "/ar/leasing", element: <LeasingPageAr /> },
  { path: "/ar/careers", element: <CareersPageAr /> },
  { path: "/ar/partner", element: <PartnerPageAr /> },
  { path: "/ar/goldcar", element: <GoldcarPageAr /> },
  { path: "/ar/truckline", element: <TrucklinePageAr /> },
  { path: "/ar/autocare", element: <Navigate to="/ar/businesses" replace /> },
  { path: "/ar/used-cars", element: <UsedCarsPageAr /> },
  { path: "/ar/auction", element: <AuctionCatalogPage lang="ar" /> },
  { path: "/ar/auction/lot/:id", element: <AuctionLotPage lang="ar" /> },
  { path: "/ar/sustainability", element: <SustainabilityPageAr /> },
  { path: "/ar/media", element: <MediaCenterPageAr /> },
  { path: "/ar/leadership", element: <LeadershipPageAr /> },
  { path: "/ar/faq", element: <FAQPageAr /> },
  { path: "/ar/downloads", element: <DownloadsPageAr /> },
  { path: "/ar/businesses", element: <BusinessesPageAr /> },
  { path: "/ar/portal/corporate", element: <PortalPageAr /> },
  { path: "/ar/portal/driver", element: <PortalPageAr /> },
  { path: "*", element: <NotFoundPage /> },
];
